import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Checkbox,
  IconButton,
  Tooltip,
  Backdrop,
  CircularProgress,
  FormHelperText,
  Button,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";

import CropSquareIcon from "@mui/icons-material/CropSquare";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import axios from "axios";
import { toast } from "react-toastify";
import { red } from "@mui/material/colors";
import ErrorAlert from "helper/errorAlert";
import { InfoRounded } from "@mui/icons-material";
import Tooltips from "components/tooltip";
import { useApiClient } from "context/ApiClientContext";

export default function AssignCompany({
  open,
  inputForm,
  userId,
  handleInputChange,
}) {
  const [rows, setRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [lastCompany, setLastCompany] = useState(inputForm.lastcompany);
  const apiClient = useApiClient();
  useEffect(() => {
    getCompany();
    if (userId) {
      getCurrentList();
    }
  }, []);

  const getCurrentList = () => {
    const bulkCompany = inputForm?.bulkcompanyuser;
    if (!bulkCompany) {
      toast.error("Bulk company data is not available.");
      return;
    }

    const listCurrentComp = bulkCompany
      .map((data, i) => {
        if (data.id !== 0) {
          return { userId: data.userid, companyId: data.companyid };
        }
        return null;
      })
      .filter((companyId) => companyId !== null);
    setSelectedRows(listCurrentComp);
    handleInputChange("bulkcompanyuser", listCurrentComp);
  };
  const getCompany = async (id) => {
    try {
      const response = await axios.get(
        `${apiClient}/company?sortcriteria=id%20desc`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            Accept: "application/json",
          },
        }
      );
      // setRows(response.data);
      const activeCompanies = response.data.filter(company => company.isActive);
      setRows(activeCompanies);
    } catch (error) {
      ErrorAlert(error);
      console.error("An error occurred:", error.response);
    }
  };

  const handleCheckboxChange = (row) => {
    const selectedIndex = selectedRows.findIndex(
      (selectedRow) => selectedRow.companyId === row.id
    );
    let newSelected = [];

    if (row.id === lastCompany) {
      setLastCompany("");
      handleInputChange("lastcompany", "");
    }

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedRows, {
        userId: userId || 0,
        companyId: row.id,
      });
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedRows.slice(1));
    } else if (selectedIndex === selectedRows.length - 1) {
      newSelected = newSelected.concat(selectedRows.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedRows.slice(0, selectedIndex),
        selectedRows.slice(selectedIndex + 1)
      );
    }

    setSelectedRows(newSelected);
    handleInputChange("bulkcompanyuser", newSelected);
  };

  const isSelected = (row) =>
    selectedRows.some((selectedRow) => selectedRow.companyId === row.id);

  const handleChange = (property, id) => {
    const value = id;
    setLastCompany(value);
    handleInputChange(property, value);
  };

  return (
    <Paper>
      <Box p={3}>
        <Typography variant="h5" mb={3} fontWeight="fontWeightMedium">
          Assign Company
          <Tooltips text={<InfoRounded />} title="At least one company is selected and set to default" />
          {/* <Tooltip title="One defaulst company is required" placement="right-end">
            <Button color="primary" sx={{fontSize: "17px"}}>
              <InfoRounded />
            </Button>
          </Tooltip> */}
        </Typography>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        // onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <Box
          sx={{ maxHeight: 400, border: "2px solid #ccc" }}
        >
          <TableContainer component={Paper}>
            <Box
              sx={{
                position: 'relative',
                height: '400px', // Adjust height as needed
                overflow: 'auto',
              }}
            >
              <Table sx={{ minWidth: 650 }} size="small">
                <TableHead
                  sx={{
                    position: 'sticky',
                    top: 0,
                    backgroundColor: 'lightgrey', // Ensure the background covers content behind it
                    zIndex: 1,
                  }}>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>Code</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Set Default</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <TableRow
                      key={row.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell>
                        <Checkbox
                          checked={isSelected(row)}
                          onChange={() => handleCheckboxChange(row)}
                        />
                      </TableCell>
                      <TableCell>{row.code}</TableCell>
                      <TableCell>{row.name}</TableCell>
                      <TableCell>
                        <IconButton
                          color="primary"
                          key="defaultCompany"
                          onClick={() => handleChange("lastcompany", row.id)}
                          disabled={!isSelected(row)}
                        >
                          {isSelected(row) ? (
                            lastCompany === row.id ? (
                              <CheckBoxIcon />
                            ) : (
                              <CropSquareIcon />
                            )
                          ) : (
                            <Tooltip
                              title="Set default company"
                              placement="right"
                            >
                              <CropSquareIcon />
                            </Tooltip>
                          )}
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </TableContainer>
        </Box>
      </Box>
    </Paper>
  );
}
